import ContainerSignIn from "./Components/ContainerSignIn"
export default function SignIn() {
  return (
    <div className="relative flex justify-center items-center h-screen bg-zi-bg1-light dark:bg-zi-bg1-dark">
      <ContainerSignIn text="ورود به ناحیه مدیریت سامانه"/>
      <span className="absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
    </div>
  )
}